import { combineReducers } from 'redux';

import token from './token/slice';
import user from './user/slice';

const authReducer = combineReducers({
  token,
  user,
});

export default authReducer;
